import { Button, Typography, Modal, ModalTitle, ModalContent, ModalActions } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface ConfirmNavigationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

/**
 * Confirmation modal that shows a warning when navigating away with unsaved changes
 */
export const ConfirmNavigationModal = (props: ConfirmNavigationModalProps) => {
    const { isOpen, onClose, onConfirm } = props;

    const baseClassName = "kms-ds-edit-playlist-header-confirmation-modal";

    return (
        <Modal open={isOpen} className={baseClassName}>
            <ModalTitle className={`${baseClassName}-title`}>{translate("Leave without saving?")}</ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                <Typography>{translate("Are you sure you want to go back without saving your changes?")}</Typography>
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    variant="borderless"
                    color="secondary"
                    onClick={onClose}
                    className={`${baseClassName}-actions-cancel`}
                >
                    {translate("Keep editing")}
                </Button>
                <Button color="danger" onClick={onConfirm} className={`${baseClassName}-actions-confirm`}>
                    {translate("Leave without saving")}
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default ConfirmNavigationModal;
